
export class Section {
	[key: string]: string;

	sparteId = '';
	sparteBeshreibung = '';
	sparteBezeichnung = '';
}


export class Twig {

	label = ''; 
	id = '';
	currency = true;
	info = "";

	constructor( label: string, id: string, currency: boolean = true, info: string = "" ) {
        this.label = label;
		this.id = id;
		this.currency = currency;
		this.info = info;
    }

}


